import { render } from "./ConnectWalletButton.vue?vue&type=template&id=1c226205&scoped=true"
import script from "./ConnectWalletButton.vue?vue&type=script&lang=js"
export * from "./ConnectWalletButton.vue?vue&type=script&lang=js"

import "./ConnectWalletButton.vue?vue&type=style&index=0&id=1c226205&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c226205"]])

export default __exports__